import React, { useCallback, useRef, useState, forwardRef, useImperativeHandle, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./CriminalHistoryDisclosureView.module.css";

import { AddButton, InputBox, CheckboxItem } from "@cpnw/ui";
import DashboardRadio from "components/DashboardRadio";
import FormDatePicker from "components/FormDatePicker";
import { DATE_FORMAT_PATTERN } from "pages/enums";

const CriminalHistoryDisclosureView = forwardRef(({
  data = {},
  onChange,
  disabled = false,
  onValidate }, ref) => {

  const [disclosureSignatureDates, setDisclosureSignatureDates] = useState(data.disclosureSignatureDates || [{}]);
  const [error, setError] = useState('');

  useImperativeHandle(ref, () => ({
    validator: () => {
      const errors = {};
      setError('');
      data.disclosureSignatureDates = disclosureSignatureDates.filter(
        (entry) => entry.dateOfDisclosureSignature
      );
      setDisclosureSignatureDates(
        data.disclosureSignatureDates.length ? data.disclosureSignatureDates : [{}]
      );
      onValidate({});
      return null; // No errors
    },
  }));

  const setValue = (key, value) => {
    if (key) {
      data[key] = value;
    }

    if (onChange) {
      onChange({ ...data });
    }
  };

  return (
    <>
      <div className={styles.container}>
        {disclosureSignatureDates.map((date, index) => (
          <div className={styles.testRow} key={index}>
            <FormDatePicker
              label="Date of Disclosure Signature"
              dateFormat={DATE_FORMAT_PATTERN}
              dateString={date.dateOfDisclosureSignature}
              setDate={(dateString) => {
                const newDates = [...disclosureSignatureDates];
                newDates[index].dateOfDisclosureSignature = dateString;
                setDisclosureSignatureDates(newDates);
                setValue("disclosureSignatureDates", newDates);
              }}
              disabled={disabled}
            />
            {!disabled && (
              <button
                type="button"
                className={styles.removeButton}
                aria-label="Remove"
                onClick={() => {
                  const newDates = disclosureSignatureDates.filter((_, i) => i !== index);
                  setDisclosureSignatureDates(newDates);
                  setValue("disclosureSignatureDates", newDates);
                }}
              >
                x
              </button>
            )}
          </div>
        ))}
        {!disabled && (
          <div className={styles.addButtonContainer}>
            <AddButton
              onClick={() => setDisclosureSignatureDates([...disclosureSignatureDates, {}])}
              label="Disclosure Signature Date"
            />
          </div>
        )}
      </div>
    </>
  );
})

export default CriminalHistoryDisclosureView;
